import React, { Component, Fragment } from "react";
import { Radio, Form, Tabs, Select } from "antd";
import { inject, observer } from "mobx-react";
import SimpleSiteList from "components/SimpleSiteList";
import { ModuleMap, ModuleValue } from "common/modules";
import co from "co";

const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const Option = Select.Option;

var moduleFormatter = function(params) {
	return ModuleMap[params.value];
};

var doFollowRenderer = function(params) {
	if (params.node.group == true) {
		return null;
	}
	if (params.value == true) {
		return "<span>Yes</span>";
	} else {
		return "<span>No</span>";
	}
};

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},

	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class SitesForm extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.props.form.validateFieldsAndScroll((err, vals) => {
				resolve(err);
			});
		});
	};

	createColumnDefs(props) {
		return [
			{
				headerName: "Module",
				field: "id.module",
				valueFormatter: moduleFormatter,
				editable: false,
				hide: false,
				rowGroupIndex: 0
			},
			{
				headerName: "Platform",
				field: "platform",
				editable: false,
				hide: false,
				rowGroupIndex: 1
			},
			{
				field: "id",
				headerName: "ID",
				editable: false,
				hide: true
			},
			{
				headerName: "DA",
				field: "pr",
				width: 100,
				editable: false,
				floatCell: true,
				filter: "agNumberColumnFilter",
				filterParams: {
					filterOptions: ["greaterThanOrEqual"],
					cellHeight: 20,
					newRowsAction: "keep"
				}
			},
			{
				headerName: "Dofollow",
				field: "dofollow",
				width: 150,
				editable: false,
				cellRenderer: doFollowRenderer,
				filter: "agSetColumnFilter"
			}
		];
	}

	render() {
		let tier = this.props.tier;
		const radioStyle = {
			display: "block",
			height: "30px",
			lineHeight: "30px"
		};

		let currentSiteSelectionType = this.props.form.getFieldValue(
			`tierSiteSelection[${tier}].type`
		);

		let customSiteSelectionSection = "";
		let manualSiteSection = "";

		if (currentSiteSelectionType != undefined) {
			if (currentSiteSelectionType == 2) {
				customSiteSelectionSection = (
					<FormItem style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator(
							`tierSiteSelection[${tier}].siteSelectionId`,
							{
								rules: [
									{
										required: true,
										message:
											"Please choose a site selection profile"
									}
								]
							}
						)(
							<Select
								style={{ width: 200 }}
								placeholder="Select a site selection profile"
							>
								{this.props.customSiteSelections.map(item => {
									return (
										<Option key={item.id} value={item.id}>
											{item.name}
										</Option>
									);
								})}
							</Select>
						)}
					</FormItem>
				);
			} else if (currentSiteSelectionType == 3) {
				manualSiteSection = (
					<Fragment>
						<div
							style={{
								width: "100%",
								height: (window.screen.height * 3) / 4
							}}
						>
							<SimpleSiteList
								sites={this.props.sites}
								columnDefs={this.createColumnDefs()}
								ref={siteList => {
									if (siteList != null) {
										this.siteList =
											siteList.wrappedInstance;
									}
								}}
							/>
						</div>
					</Fragment>
				);
			}
		}

		return (
			<FormItem>
				{this.props.form.getFieldDecorator(
					`tierSiteSelection[${tier}].type`
				)(
					<RadioGroup>
						<Radio style={radioStyle} value={1}>
							All Sites
						</Radio>
						<Radio style={radioStyle} value={2}>
							Site Selection Profile
						</Radio>
						{customSiteSelectionSection}
						<Radio style={radioStyle} value={3}>
							Manually
						</Radio>
					</RadioGroup>
				)}
				{manualSiteSection}
			</FormItem>
		);
	}
}

@inject("rootStore")
@observer
class TierTabs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: "tier1"
		};
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.setState({ activeKey });
	};

	render() {
		return (
			<Tabs
				tabPosition="left"
				activeKey={this.state.activeKey}
				onChange={this.handleTabChange}
				animated={false}
			>
				{this.props.tabPanes}
			</Tabs>
		);
	}
}

@inject("rootStore")
@observer
class SitesTab extends Component {
	internalForms = [];

	validateForm = () => {
		return co(
			function*() {
				for (let tier = 0; tier < this.internalForms.length; tier++) {
					let internalForm = this.internalForms[tier];
					let result = yield internalForm.validateForm();
					if (result != null) {
						this.tierTabs.setActiveKey(`tier${tier + 1}`);
						return result;
					}
				}
				return null;
			}.bind(this)
		);
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;

		let data = {
			tierSiteSelection: []
		};

		for (let i = 0; i < stateForm.tierSiteSelection.length; i++) {
			let siteSelection = stateForm.tierSiteSelection[i];
			data.tierSiteSelection.push({
				type: Form.createFormField(siteSelection.type),
				siteSelectionId: Form.createFormField(
					siteSelection.siteSelectionId &&
						//TODO: siteSelection.siteSelectionId.value != 0
						siteSelection.siteSelectionId.value != null
						? siteSelection.siteSelectionId
						: { value: undefined }
				)
			});
		}

		return data;
	};

	render() {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;

		const fields = this.mapPropsToFields();
		const customSiteSelections = xwizardStore.customSiteSelections;

		let tabPanes = [];
		this.internalForms = [];
		const tierSites = xwizardStore.tierSites;

		for (let tier = 0; tier < stateForm.tierSiteSelection.length; tier++) {
			let tabName = `Tier ${tier + 1}`;
			let tabKey = `tier${tier + 1}`;
			let sites = tierSites[tier];
			let tabPane = (
				<TabPane tab={tabName} key={tabKey} forceRender={true}>
					<p>
						Select the websites on <b>{tabName}</b> that you want to
						post to
					</p>
					<Form>
						<SitesForm
							tier={tier}
							fields={fields}
							sites={sites}
							customSiteSelections={customSiteSelections}
							onFieldsChange={this.onFieldsChange}
							wrappedComponentRef={internalForm => {
								if (internalForm != null) {
									this.internalForms.push(internalForm);
								}
							}}
						/>
					</Form>
				</TabPane>
			);
			tabPanes.push(tabPane);
		}
		return (
			<TierTabs
				tabPanes={tabPanes}
				ref={tierTabs => {
					if (tierTabs != null) {
						this.tierTabs = tierTabs.wrappedInstance;
					}
				}}
			/>
		);
	}
}

export default SitesTab;
